import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import { ff } from '@atlassian/jira-feature-flagging';
import { type LoadAppDataAction, loadAppData } from '../../state/actions/app';
import {
	type ClearExpandedCardGroupAction,
	clearExpandedCardGroup,
} from '../../state/actions/card-list';
import {
	cardCreateUnmappedWithIssueLink,
	type CardCreateUnmappedWithIssueLinkAction,
} from '../../state/actions/cards/create';
import { CARD_STATUS_SET, type CardStatusSetAction } from '../../state/actions/status';
import { getIsCompanyManaged, isCmpKanbanProject } from '../../state/selectors/app';
import { makeCardKeyFromCardId } from '../../state/selectors/cards';
import {
	areStatusesFromSameColumn,
	isStatusMappedToBoard,
	isStatusVisibleOnCmpKanbanBacklog,
} from '../../state/selectors/statuses';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

type OutputAction =
	| CardCreateUnmappedWithIssueLinkAction
	| LoadAppDataAction
	| ClearExpandedCardGroupAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(CARD_STATUS_SET)
		.mergeMap((action: CardStatusSetAction): Observable<OutputAction> => {
			const {
				payload: { cardId, prevStatusId, statusId },
			} = action;
			const state = store.getState();
			const cardKey = makeCardKeyFromCardId(state)(cardId);

			if (!isStatusMappedToBoard(state)(statusId)) {
				return Observable.of(cardCreateUnmappedWithIssueLink([{ id: cardId, key: cardKey }]));
			}

			if (isCmpKanbanProject(state)) {
				const statusIdIsVisible = isStatusVisibleOnCmpKanbanBacklog(state)(statusId);
				const cardHasMovedColumn = !areStatusesFromSameColumn(state)(prevStatusId, statusId);

				if (!statusIdIsVisible || cardHasMovedColumn) {
					return Observable.from([loadAppData(), clearExpandedCardGroup(cardId)]);
				}
			}

			const isCMP = getIsCompanyManaged(state);
			if (ff('jsw.uif.backlog.fix-strikethrough-on-status-transition') && isCMP) {
				// For CMP, always do a data refresh on status transition
				// to ensure the issue's resolution is correct.
				return Observable.from([loadAppData()]);
			}

			return Observable.empty<never>();
		});
